<template>
  <div style='background-color: white;padding: 10px;border-radius: 8px;;height: calc(100vh - 132px);overflow-y: hidden'>
    <searchForm :formOptions="formOptions"  @onSearch="onSearch" :btnItems='btnItems' @onExport='onExport' @setSelect = 'setSelect'/>
    <div class='title'>
      {{ startTime }} 至 {{ endTime }} 共{{day}}天  日均耗料<span style='color:black'> {{ avg }} </span>吨,
      合计耗料 <span style='color:black'>{{ count }}</span> 吨,
      来料 <span style='color:black'>{{ coming }}</span> 吨 </div>
    <page-table
      v-loading="loading"
      :tableData="tableData"
      :tableLabel="tableLabel"
      :tableOption="tableOption"
      class="gdtable"
      :pager="pager"
      :tableId='"eleLog"'
      @pagination='handleCurrentChange'
      @handleSizeChange='handleSizeChange'
      @handleButton='tableBtnHandle(arguments)'
    ></page-table>
  </div>
</template>

<script>
import pageTable from '@/components/pageTable'
import searchForm from "@/components/searchForm";
import moment from 'moment'
import { exportExcel, numberTran, tranBuildType } from '../../libs/tools'
import store from '../../store'
import axios from "axios";
import {getDownload} from "../../libs/axios";

export default {
  name:'foodLog',
  components:{
    pageTable,
    searchForm
  },
  data(){
    return{

      selectBuildId:'',
      buildType:'',
      loading:true,
      btnItems: 'search'+'export'+'reset',
      startTime: moment().format('yyyy/MM/DD'),
      endTime: moment().format('yyyy/MM/DD'),
      obj: {
        buildType:undefined,
        buildId:undefined,
        deviceId:undefined,
        startTime: moment().format('yyyy-MM-DD') + ' 00:00:00',
        endTime: moment().format('yyyy-MM-DD') +' 23:59:59'
      },
      day: 1,
      count: 0,
      coming: 0,
      avg: 0,
      formOptions: [
        {
          label: '栋舍',
          prop: 'buildingId',
          element: 'el-select',
          options: this.getBuildType(),
          isChange: 'change'
        }, {
          label: '单元/区',
          prop: 'buildId',
          element: 'el-select',
          showTooltip:true,
          options: []
        },
        {
          label: '设备名称',
          prop: 'deviceName',
          element: 'el-input',
          placeholder:'请输入设备名称'
        },
        {
          label: '时间',
          prop: 'date',
          initValue: [new Date(),new Date()],
          type: 'daterange',//monthrange | datetimerange | daterange |date
          element: 'el-date-picker'
        }
      ],
      tableData: [],
      tableLabel: [
        {
          label: '料塔名称',
          param: 'deviceName'
        },{
          label: '栋舍',
          param: 'buildingName'
        },{
          label: '单元/区',
          param: 'buildName'
        },
        // {
        //   label: '单元类型',
        //   param: 'buildType'
        // },
        {
          label: '日均耗料(kg)',
          param: 'avgDay',
          align: 'right'
        },{
          label: '耗料小计(kg)',
          param: 'amount',
          align: 'right'
        },{
          label: '来料小计(kg)',
          param: 'coming',
          align: 'right'
        },{
          label: '是否统计',
          param: 'notCount',
        },
      ],
      tableOption: {

      },
      pager:{
        pageSize: 10,  // 每页数据量
        currentPage: 1, // 分页  当前页
        total:0,  //列表总数
      }
    }
  },
  watch:{
    buildType(val){
      this.getAllPigpen(val)
    }
  },
  mounted() {
    this.init()
  },
  methods:{
    init(){
      this.getFoodLog(this.obj)
      this.getLogCount(this.obj)
      this.getAllPigpen()
    },
    setSelect(val){
      this.selectBuildId = val
      this.buildType = val;
    },
    //料塔历史记录
    getFoodLog(obj) {
      let that = this
      this.$http.get(this.$api.feedLog, {
        ...obj,
        deviceType: '料塔',
        current: that.pager.currentPage,
        size: that.pager.pageSize
      }).then(res => {
        if (res.data){
          let arr = res.data.records
          arr.map(item => {
            item.buildType =  tranBuildType(item.buildType)
            item.avgDay = numberTran( Math.floor(item.amount/that.day))
            item.amount = numberTran( item.amount)
            item.coming = numberTran( item.coming)
            item.notCount = item.notCount ? '不统计' : '统计'
          })
          this.tableData = arr
          this.pager.total = res.data.total
          this.loading = false
        }else {
          this.loading = false
        }
      })
    },
    //料塔历史统计
    getLogCount(obj) {
      let that = this
      this.$http.get(this.$api.getFeedLogCount, {
        ...obj,
        deviceType: '料塔'
      }).then(res => {
        if (res.data.amount!=null){
          that.count = res.data.amount
          this.avg = Math.floor( (that.count/that.day * 100))/100
        }
        if (res.data.coming!=null){
          that.coming = res.data.coming
        }

      })
    },
    //单元类型
    getBuildType() {
      let arr = []
      this.$http.get(this.$api.getBuildList, {
        deviceType: '料塔'
      }).then(res => {
        if (res.data) {
          let list = Array.from(new Set(res.data))
          list.map(item => {
            arr.push({
              label: item.name,
              value: item.id
            })
          })
        }
      })
      return arr
    },
    loadTable(val){
      this.loading = true
      this.getFoodLog(val)
      this.getLogCount(val)
    },
    tableBtnHandle(arg){
      console.log(arg[0])
      console.log(arg[1])
    },
    //翻页
    handleCurrentChange(val) {
      this.pager.currentPage = val
      this.loadTable(this.obj)
    },
    //页码大小
    handleSizeChange(val) {
      this.pager.pageSize = val
      this.loadTable(this.obj)
    },
    onSearch (val) {
      if (val==null){
        return
      }
      this.$set(this.pager,'currentPage',1)
      if(val.date!=null){
        this.day =  moment(val.date[1]).diff(moment(val.date[0]),'d') + 1
        this.obj.startTime = moment(val.date[0]).format('yyyy-MM-DD') + ' 00:00:00'
        this.startTime = moment(val.date[0]).format('yyyy/MM/DD')
        this.obj.endTime = moment(val.date[1]).format('yyyy-MM-DD') + ' 23:59:59'
        this.endTime = moment(val.date[1]).format('yyyy/MM/DD')
      }else {
        this.$message.warning("请选择日期")
        return
      }
      this.obj.buildId = val.buildId
      this.obj.buildingId = val.buildingId
      this.obj.deviceName = val.deviceName
      this.loadTable(this.obj)
    },
    //栋舍列表
    getAllPigpen(val) {
      let arr = []
      this.formOptions[1].options = []
      this.$http.get(this.$api.getAllPigpen, {
        deviceType: '料塔',
        buildingId:this.selectBuildId
      }).then(res => {
        console.log(res)
        if (res.data){
          res.data.map(item => {
            arr.push({
              label: item.name,
              value: item.id
            })
          })
          this.formOptions[1].options  = arr
        }
      })
    },
    onExport(val){
      if(val.date!=null){
        this.day =  moment(val.date[1]).diff(moment(val.date[0]),'d') + 1
        this.obj.startTime = moment(val.date[0]).format('yyyy-MM-DD') + ' 00:00:00'
        this.startTime = moment(val.date[0]).format('yyyy/MM/DD')
        this.obj.endTime = moment(val.date[1]).format('yyyy-MM-DD') + ' 23:59:59'
        this.endTime = moment(val.date[1]).format('yyyy/MM/DD')
      }else {
        this.$message.warning("请选择日期")
        return
      }
      this.obj.buildId = val.buildId
      this.obj.buildingId = val.buildingId
      this.obj.buildType = val.buildType
      this.obj.deviceName = val.deviceName
      this.loadTable(this.obj)
      this.exportHisWaterList(this.obj)
    },
    //列表导出
    exportHisWaterList(obj) {
      // let urls = store.state.baseUrl+this.$api.exportHisFeedList +'?deviceType=料塔&current=-1&size=-1&farmId=' + store.state.farmId
      // let buildType = ""
      // let buildName = ""
      // let startTime = ""
      // let endTime = ""
      // let deviceName = ""
      // if (obj.buildType){
      //   buildType = obj.buildType
      //   urls = urls + '&buildType=' + buildType
      // }
      // if (obj.buildName){
      //   buildName = obj.buildName
      //   urls = urls + '&buildName=' + buildName
      // }
      // if (obj.startTime){
      //   startTime = obj.startTime
      //   urls = urls + '&startTime=' + startTime
      // }
      // if (obj.endTime){
      //   endTime = obj.endTime
      //   urls = urls + '&endTime=' + endTime
      // }
      // if (obj.deviceName){
      //   deviceName = obj.deviceName
      //   urls = urls + '&deviceName=' + deviceName
      // }
      // window.location.href = urls
      axios.defaults.headers.common['x-auth-token'] = localStorage.getItem('token');
      let headers = {
        'x-auth-token': localStorage.getItem('token')
      }
      getDownload(this.$api.exportHisFeedList,{
        farmId:store.state.farmId,
        ...obj
      },headers).then((res) => {
        let blob = new Blob([res.data])
        let downloadElement = document.createElement('a')
        let href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        // downloadElement.download = decodeURIComponent(res.headers.filename); //下载后文件名
        downloadElement.download = `料塔历史记录.xlsx`; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放blob对象
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .gdtable .el-table__body-wrapper {
    height: calc(100vh - 327px) !important;
    overflow-y: auto !important;
}
.title {
  margin-bottom: 10px;
  color: #606266;

}
::v-deep .el-range-separator {
  padding: 0 5px;
  line-height: 22px;
  width: 7%;
  color: #303133;
}
</style>
